import { Outlet } from 'react-router-dom';
import { DateRangeProvider, useDateRange } from '../../../contexts/DateRangeContext';
import { AgentFilterProvider } from '../../../contexts/AgentFilterContext';
import { AtlasTimeRangeScope } from '../../agent-atlas/hooks/AtlasTimeRangeScope';

// Atlas pages mounted under /gemini/agents read Gemini Enterprise's own window
// (30 days, per session, shared by every GE page) rather than the app-wide
// Atlas one, so a GE page drawn by Atlas agrees with the GE pages around it.
const GeminiAtlasWindow = ({ children }) => {
  const { dateRange, dateParams, handleDateChange } = useDateRange();
  return (
    <AtlasTimeRangeScope rangeKey={dateRange} dateRange={dateParams} setRange={handleDateChange}>
      {children}
    </AtlasTimeRangeScope>
  );
};

// The module's agent/user selection (2026-10-11: back, as the Atlas Filters dropdown in
// each page's filter bar under its title, beside the date pills — ModuleScopeBar). It is
// per session and shared by every GE page; a page that honours it draws it in that bar,
// so a selection never narrows a page without saying so. Pages whose data carries no agent or
// person (Settings, Licensing, Budgets, Recommendations, and the Security Skills, Playbooks,
// Response, Exceptions and AI-BOM pages) neither read it nor show it.

const GeminiAgentsLayout = () => (
  <DateRangeProvider>
    <AgentFilterProvider storageKey="gemini_agents_filters">
      <GeminiAtlasWindow>
        <Outlet />
      </GeminiAtlasWindow>
    </AgentFilterProvider>
  </DateRangeProvider>
);

export default GeminiAgentsLayout;
